export default "__VITE_ASSET__DiK1p8Dy__"